<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
                </header>
            </section>
            <section class="widget">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                    <inputCustom [titulo]="'Ciclo'" [disabled]="true" [(ngModel)]="entidad.ciclo" [errorActivo]="errorActivo" ></inputCustom>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                    <inputCustom [titulo]="'Nombre del periodo de evaluación'" [disabled]="true" [(ngModel)]="entidad.descripcion" [errorActivo]="errorActivo" ></inputCustom>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <inputCustom [titulo]="'Tipo de evaluación'" [disabled]="true" [(ngModel)]="accion.entidad.nombre" [errorActivo]="errorActivo" ></inputCustom>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <inputCustom [titulo]="'Nivel'" [disabled]="true" [(ngModel)]="accion.entidad.nivel" [errorActivo]="errorActivo" ></inputCustom>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                  <inputCustom [titulo]="'Grado'" [disabled]="true" [(ngModel)]="accion.entidad.grado" [errorActivo]="errorActivo" ></inputCustom>
              </div>
            </div>

            <div *ngIf="tipoevaluacionid == 3 || tipoevaluacionid == 4 || tipoevaluacionid == 2">
              <h5>Asigne las materias que serán evaluadas por los alumnos</h5>
                <dx-data-grid
                      id="tabla"
                      [dataSource]="DataMaterias"
                      [remoteOperations]="false"
                      [allowColumnReordering]="true"
                      [rowAlternationEnabled]="true"
                      [noDataText]="'Sin Datos'"
                      [(selectedRowKeys)]="selectedRows"
                      [remoteOperations]="{ groupPaging: true }"
                      (onContentReady)="contentReady($event)"
                    >
                      <dxo-paging [pageSize]="0"></dxo-paging>

                      <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
                      <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
                      <dxo-selection mode="multiple" [showCheckBoxesMode]="'always'" *ngIf="!visualizador"></dxo-selection>
                      <dxi-column [allowEditing]="!visualizador" *ngIf="visualizador"
                      alignment="center"
                      dataField="activo"
                      caption="Selección"
                      dataType="boolean"
                  >
                  </dxi-column>
                      <dxi-column dataField="grupo" caption="Grupo" [groupIndex]="0" groupCellTemplate="groupCellTemplate"></dxi-column>
                      <dxi-column dataField="requieremaestrotitular" caption="Tipo de Materia" dataType="string" [allowEditing]="false"></dxi-column>
                      <dxi-column dataField="materia" caption="Materia" dataType="string" [allowEditing]="false"></dxi-column>
                      <dxi-column dataField="profesor" caption="Profesor" [allowEditing]="false"></dxi-column>

                      <div *dxTemplate="let cellInfo of 'groupCellTemplate'">
                        <h5>{{accion.entidad.grado}}°{{ cellInfo.value }}</h5>
                    </div>
                </dx-data-grid>
              </div>

              <div *ngIf="tipoevaluacionid == 5 || tipoevaluacionid == 6 ">
                <h5>Asigne las materias que serán evaluadas por los alumnos</h5>
                <dx-data-grid
                      id="tabla"
                      [dataSource]="DataMaterias"
                      [remoteOperations]="false"
                      [noDataText]="'Sin Datos'"
                      [allowColumnReordering]="true"
                      [rowAlternationEnabled]="true"
                      [showBorders]="true"
                      [(selectedRowKeys)]="selectedRows"
                      [remoteOperations]="{ groupPaging: true }"
                      (onContentReady)="contentReady($event)"
                    >
                      <dxo-paging [pageSize]="0"></dxo-paging>

                      <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
                      <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
                      <dxo-selection mode="multiple" [showCheckBoxesMode]="'always'" *ngIf="!visualizador"></dxo-selection>
                      <dxi-column [allowEditing]="!visualizador" *ngIf="visualizador"
                      alignment="center"
                      dataField="activo"
                      caption="Selección"
                      dataType="boolean"
                  >
                  </dxi-column>

                      <dxi-column dataField="grupo" [groupIndex]="0"  groupCellTemplate="groupCellTemplate"></dxi-column>
                      <dxi-column dataField="materia" caption="Materia" dataType="string" [allowEditing]="false"></dxi-column>
                      <dxi-column dataField="profesor" caption="Profesor" [allowEditing]="false"></dxi-column>
                      <div *dxTemplate="let cellInfo of 'groupCellTemplate'">
                        <h5>{{accion.entidad.grado}}°{{ cellInfo.value }}</h5>
                    </div>
                </dx-data-grid>

              </div>
                <div class="divisor20"></div>
                <div class="row margen" >
                    <div class="col-12">
                        <div class="panelBotonesFiltro">
                            <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                            (click)="Salir()" [disabled]="procesando">
                            <span> {{'CANCELAR'}}</span>
                        </button>
                            <div class="divisorH16 " ></div>
                            <button matTooltip="Agregar" class="boton botonSM filled"
                            (click)="Guardar()"
                            [disabled]="procesando"
                            *ngIf="sistemaService.permisos.agregar && !visualizador">
                            <span> {{'GUARDAR'}}</span>
                        </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>
